import { render } from "./Carreta.vue?vue&type=template&id=02ba0b8b"
import script from "./Carreta.vue?vue&type=script&lang=ts"
export * from "./Carreta.vue?vue&type=script&lang=ts"
script.render = render

export default script